import { DNA_RESULTS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './DnaResults'

export default withLocalization(Component, DNA_RESULTS)
